import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Select from 'react-select'
import styled from 'styled-components'

import { setSAMLanguage } from '../../../slices/resultsPageSlice'

// export interface LanguageSelectProps {}

const StyledSelect = styled.div`
  width: 150px;
  margin-left: 10px;
  margin-right: 5px;
`

const LanguageSelect = () => {
  const dispatch = useDispatch()
  // @ts-ignore no State is defined for TypeScript
  const lang = useSelector((state) => state.resultsPage.SAMLanguage)

  const options = [
    { value: 'en', label: 'English' },
    { value: 'de', label: 'Deutsch' },
  ]

  return (
    <>
      Language for ontology
      <StyledSelect>
        <Select
          options={options}
          defaultValue={options[0]}
          value={options.filter((opt) => opt.value === lang)}
          onChange={(value) => {
            // @ts-ignore
            dispatch(setSAMLanguage(value.value))
          }}
        />
      </StyledSelect>
    </>
  )
}

export default LanguageSelect
